import { render, staticRenderFns } from "./CustomInvitationModal.vue?vue&type=template&id=56ee2e1f&scoped=true&"
import script from "./CustomInvitationModal.vue?vue&type=script&lang=js&"
export * from "./CustomInvitationModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomInvitationModal.vue?vue&type=style&index=0&id=56ee2e1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ee2e1f",
  null
  
)

export default component.exports